import Vue from "vue";
import App from "./App.vue";
import axios from "axios";
import VueAxios from "vue-axios";
import router from "./router";
import store from "./store";
import vuetify from "./plugins/vuetify";
import Vuetify from "vuetify";
import StaticTrans from "./mixins/StaticTrans";
Vue.use(VueAxios, axios, Vuetify);
Vue.mixin(StaticTrans);

axios.defaults.baseURL = "https://ba.biglike.app/api/v1/company/";
//axios.defaults.baseURL = "http://127.0.0.1:8000/api/v1/company/";
Vue.config.productionTip = false;

import "@/styles/main.scss";
new Vue({
  router,
  store,
  vuetify,
  render: (h) => h(App),
}).$mount("#app");
